import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'lib-survey-eos-link',
	templateUrl: "./survey-eos-link.component.html",
	styleUrls: ['./survey-eos-link.component.css']
})
export class SurveyEosLinkComponent implements OnInit {
	@Input() WEB_EOS_URL = "";
	surveyurl = ""
	constructor() {
	}

	ngOnInit(): void {
	}

}
